import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  editTopic: null,
  editTopicAnswer: null,
};

export const topicSlice = createSlice({
  name: 'topic',
  initialState,
  reducers: {
    setEditingTopic: (state, action) => {
      state.editTopic = action.payload;
    },

    clearEditingTopic: (state) => {
      state.editTopic = null;
    },

    setEditingTopicAnswer: (state, action) => {
      state.editTopicAnswer = action.payload;
    },

    clearEditingTopicAnswer: (state) => {
      state.editTopicAnswer = null;
    },
  },
});

export const {
  setEditingTopic,
  clearEditingTopic,
  setEditingTopicAnswer,
  clearEditingTopicAnswer,
} = topicSlice.actions;
export const selectTopic = (state) => state.topic;

export default topicSlice.reducer;
